module.exports = __webpack_public_path__ + "static/media/16c-05-ST-2016-405x295mm-oleo-sobre-papel.4d6b7030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16c/16c-05-ST-2016-405x295mm-oleo-sobre-papel.jpg
// module id = 196
// module chunks = 0